import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[requiredNoWhitespace]',
    providers: [{ provide: NG_VALIDATORS, useExisting: RequiredNoWhitespaceDirective, multi: true }],
    standalone: true,
})
export class RequiredNoWhitespaceDirective implements Validator {
	validate(control: AbstractControl): ValidationErrors {
		if (!control.value || control.value.trim() === '') {
			return { required: true };
		}

		return null;
	}
}
